import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";

const CoursePurchasedList = () => {
  const [courses, setCourses] = useState([]);
  //console.log("courses", courses);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    total: 0,
    total_page: 0,
    current_page: 1,
  });

  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [instructors, setInstructors] = useState([]);
  const [message, setMessage] = useState(null);
  //"sadha", instructors);
  const [showInstructorList, setShowInstructorList] = useState(false);

  const fetchPurchasedCourses = async (page = 1) => {
    try {
      setLoading(true);
      const res = await axiosInstance.get(
        `/admin/purchased/courses?page=${page}`
      );

      const { data } = res.data;
      setCourses(data.data);
      setPagination({
        total: data.total,
        total_page: data.total_page,
        current_page: data.current_page,
      });
    } catch (error) {
      console.error("Error fetching purchased courses:", error);
    } finally {
      setLoading(false);
    }
  };

  // const fetchInstructors = async (courseName) => {
  //   try {
  //     const res = await axiosInstance.get(`/admin/instructors`, {
  //       CourseName: courseName,
  //     });
  //     setMessage(res?.data?.message);
  //     setInstructors(res.data.data);
  //   } catch (error) {
  //     console.error("Error fetching instructors:", error);
  //   }
  // };
  const fetchInstructors = async (courseName) => {
    try {
      const res = await axiosInstance.get('/admin/instructors', {
        params: { CourseName: courseName },
      });

      //console.log("Fetched instructors:", res.data?.data);
      setMessage(res?.data?.message);
      setInstructors(res.data?.data);
    } catch (error) {
      console.error('Error fetching instructors:', error);
    }
};

  

  const handleAssignInstructorClick = (courseId, courseName) => {
    setSelectedCourseId(courseId);
    fetchInstructors(courseName);
    setShowInstructorList(true);
  };

  const handleInstructorAssign = async (instructorId) => {
    try {
      await axiosInstance.post(`/admin/assign-instructor`, {
        courseId: selectedCourseId,
        instructorId: instructorId,
      });
      alert("Instructor assigned successfully!");
      setShowInstructorList(false);
      fetchPurchasedCourses(pagination.current_page); // refresh
    } catch (error) {
      console.error("Error assigning instructor:", error);
      alert("Failed to assign instructor.");
    }
  };

  useEffect(() => {
    fetchPurchasedCourses();
  }, []);

  const handlePageChange = (newPage) => {
    fetchPurchasedCourses(newPage);
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Purchased Courses</h2>
      <div className="instructor-table">
        {loading ? (
          <Loading />
        ) : courses.length > 0 ? (
          // <div className="overflow-x-auto">
          <table className="table-width-100">
            <thead>
              <th>Sr. No.</th>
              <th>Course Title</th>
              <th>Instructor</th>
              <th>Student</th>
              <th>Price</th>
              <th>Purchased On</th>
              <th>Actions</th>
            </thead>
            <tbody>
              {courses.map((course, index) => (
                <tr key={course.id}>
                  <td className="cell">
                    {(pagination.current_page - 1) * 10 + index + 1}
                  </td>
                  <td className="cell">{course.CourseName}</td>
                  <td className="cell">
                    {course.instructorName
                      ? course.instructorName
                      : course.adminName}
                  </td>
                  <td className="cell">{course.studentName}</td>
                  <td className="cell">₹{course.EnrollmentFee}</td>
                  <td className="cell">
                    {new Date(course.orderCreatedOn).toLocaleDateString()}
                  </td>
                  <td className="border px-2 py-1">
                    {course.adminName ? (
                      <button
                        className="bg-blue-600 text-white px-2 py-1 rounded text-sm"
                        onClick={() =>
                          handleAssignInstructorClick(
                            course.ID,
                            course.CourseName
                          )
                        }
                      >
                        Assign Instructor
                      </button>
                    ) : (
                      <span className="!text-white">
                        {course.instructorName}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          // </div>
          <h2 className="no-data-found">No data found</h2>
        )}
      </div>
      {/* Pagination */}
      {pagination.total_page > 1 && (
        <div className="flex justify-center items-center mt-6 space-x-2">
          {[...Array(pagination.total_page)].map((_, idx) => (
            <button
              key={idx}
              onClick={() => handlePageChange(idx + 1)}
              className={`px-3 py-1 rounded border ${
                pagination.current_page === idx + 1
                  ? "bg-blue-600 text-white"
                  : "bg-white text-gray-700"
              }`}
            >
              {idx + 1}
            </button>
          ))}
        </div>
      )}
      {showInstructorList && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Select Instructor</h3>
            <ul className="max-h-64 overflow-y-auto border-b-2">
              {instructors?.map((instructor) => (
                <li
                  key={instructor.id}
                  className="mb-2 flex justify-between items-center"
                >
                  <p>{instructor.name}</p>
                  <button
                    onClick={() => handleInstructorAssign(instructor.id)}
                    className="bg-green-600 text-white px-3 py-1 rounded text-sm"
                  >
                    Assign
                  </button>
                </li>
              ))}
            </ul>
            <div className="flex justify-between items-center mt-4">
              <p className="text-red-500 text-xs">
                {message == null ? "" : message}
              </p>
              <button
                onClick={() => setShowInstructorList(false)}
                className=" px-4 py-1 bg-gray-400 text-white rounded"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CoursePurchasedList;
